import { render, staticRenderFns } from "./pointTask.vue?vue&type=template&id=1f0b2a3a&scoped=true"
import script from "./pointTask.vue?vue&type=script&lang=js"
export * from "./pointTask.vue?vue&type=script&lang=js"
import style0 from "./pointTask.vue?vue&type=style&index=0&id=1f0b2a3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0b2a3a",
  null
  
)

export default component.exports